module.exports = __webpack_public_path__ + "static/img/113.5bb34ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/191007/113.jpg
// module id = c95x
// module chunks = 0